// extracted by mini-css-extract-plugin
export default {"container":"Oi_UPU"};